import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  const failures = ['Los cursos de "Prompt Engineering" son para programadores, no para gente que tiene que entregar un reporte en 15 minutos.', 'Los prompts gratuitos de internet son demasiado vagos y no conocen el contexto de tu empresa.', 'La mayoría de las herramientas de productividad solo sirven para organizar tu agotamiento, no para eliminarlo.', 'Te dijeron que tenías que "aprender IA", cuando lo que necesitas es que la IA aprenda de ti.'];
  return <section className="py-20 bg-[#0a0f1a]" data-id="element-1">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <FadeIn data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12" data-id="element-4">
            Por qué lo que intentaste{' '}
            <span className="text-red-400" data-id="element-5">no funcionó</span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-6">
          {failures.map((text, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-7">
              <div className="bg-[#111827] border border-slate-800 p-6 rounded-xl flex items-start gap-4 hover:border-red-500/30 transition-colors" data-id="element-8">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-9" />
                <p className="text-[#d1d5db] text-lg leading-relaxed" data-id="element-10">{text}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}